import { useRef, Fragment, useState, useEffect } from "react";

import CalendarHeader from "../components/Calendar/CalendarHeader";
import CalendarComponent from "../components/Calendar/CalendarComponent";
import CalendarQuoteModal from "./Modals/CalendarQuoteModal";

import { load_quotes_calendar } from "../actions/agenda_content";

import "../styles/calendar.scss";
import { load_users_short } from "../actions/user_content";
import { load_actives_list } from "../actions/management_content";

const CalendarContainer = ({ profileId, patientId }) => {
  const calendarRef = useRef(null);
  const nowDate = new Date();

  const [dateValues, setDateValues] = useState({
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
  });

  const [calendarEvents, setCalendarEvents] = useState([]);
  const [isCalendarReady, setIsCalendarReady] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [modalId, setModalId] = useState(false);
  const [quoteOptions, setQuoteOptions] = useState({
    services: [],
    professionals: [],
  });
  const fetchQuoteOptions = async () => {
    const actives = await load_actives_list({ active_type: "service" });
    const professionals = await load_users_short({ profile_type: "CLI,CYG" });
    const options = {
      services: actives ? actives.service : [],
      professionals: professionals ? professionals : [],
    };
    if (options) {
      setQuoteOptions(options);
    }
  };
  const handleEventEdit = (clickInfo) => {
    setModalId(clickInfo.event.id);
    setModalShow(!modalShow);
  };
  function handleEventCreate() {
    setModalShow(!modalShow);
  }
  const handleCalendarChange = (year, month) => {
    setDateValues({
      year: year,
      month: month,
    });
    fetchCalendarQuotes({ year, month });
  };
  const fetchCalendarQuotes = async (calendarDates) => {
    const { year, month } = calendarDates;

    const data = await load_quotes_calendar({
      year,
      month,
      professional: profileId,
      patient: patientId,
    });
    if (data) {
      setCalendarEvents(data);
    }
  };

  useEffect(() => {
    calendarRef.current.getApi().removeAllEvents();
    calendarRef.current.getApi().addEventSource([...calendarEvents]);
    fetchCalendarQuotes(dateValues);
    fetchQuoteOptions();
    if (calendarRef.current) {
      setIsCalendarReady(true);
    }
  }, [calendarRef.current]);

  return (
    <Fragment>
      {isCalendarReady && (
        <CalendarHeader
          calendarRef={calendarRef}
          addEvent={handleEventCreate}
          dateValues={dateValues}
          handleCalendarChange={handleCalendarChange}
        />
      )}
      <CalendarComponent
        events={calendarEvents}
        handleEventEdit={handleEventEdit}
        calendarRef={calendarRef}
      />

      <CalendarQuoteModal
        show={modalShow}
        onHide={() => {
          setModalId(null);
          setModalShow(false);
          fetchCalendarQuotes(dateValues);
        }}
        quoteId={modalId}
        quoteOptions={quoteOptions}
      />
    </Fragment>
  );
};

export default CalendarContainer;
